// SecretCodeBottomSection.jsx
import React, { useEffect, useRef, useState } from 'react';
import './SecretCode.css';

const SecretCodeBottomSection = ({ show, secretCode }) => {
  const [remainingTime, setRemainingTime] = useState(0);
  const [completed, setCompleted] = useState(false);
  const [showCode, setShowCode] = useState(false);
  const bottomTimerRef = useRef(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    if (show) {
      sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
      const countdown = Math.floor(Math.random() * 51) + 15;
      setRemainingTime(countdown);
      bottomTimerRef.current = setInterval(() => {
        setRemainingTime(prev => {
          if (prev <= 1) {
            clearInterval(bottomTimerRef.current);
            setCompleted(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  }, [show]);

  if (!show) return null;

  return (
    <section className="bottom-section" ref={sectionRef}>
      {!completed && <div className="timer">{remainingTime}</div>}

      {completed && !showCode && (
        <button className="scroll-button" onClick={() => setShowCode(true)}>
          <i className="fas fa-hand-point-right"></i> Reveal Secret Code <i className="fas fa-hand-point-left"></i>
        </button>
      )}

      {showCode && (
        <div id="secret_code_container">
          <div className="secret-icon"><i className="fas fa-unlock-alt"></i></div>
          <div className="secret-title">Your Secret Code:</div>
          <div id="secret_code" onClick={() => navigator.clipboard.writeText(secretCode)}>
            {secretCode}
            <span className="copy-tooltip">Copied!</span>
          </div>
          <button className="copy-button" onClick={() => navigator.clipboard.writeText(secretCode)}>
            <i className="fas fa-copy"></i>&nbsp; Copy Code
          </button>
        </div>
      )}
    </section>
  );
};

export default SecretCodeBottomSection;
